import { URGENCY } from '../../config/settings.js';
import { state, subscribe } from '../../state/store.js';
import { isUnavailable } from './cart.js';

const SVG = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="13" r="7"/><path d="M12 9v4l3 2"/><path d="M9 3h6"/></svg>`;

/**
 * Lowest tracked-stock value across the current cart's lines. Lines whose
 * variant doesn't track inventory (stock === null) are ignored. Returns
 * null when no line in the cart has tracked stock.
 */
function lowestStockInCart() {
  const lines = state.cart?.lines || [];
  let min = Infinity;
  for (const l of lines) {
    // Skip lines the rest of the UI has marked unbuyable, and backorder lines
    // (which report 0 or negative stock by design). Counting them produced
    // "Поспішайте! Лише 0 товарів в наявності!" — or "Лише -3" — directly above
    // a line labelled sold out. Only a positive count is worth urging on.
    if (isUnavailable(l) || l.backorder) continue;
    if (typeof l.stock === 'number' && Number.isFinite(l.stock) && l.stock > 0) {
      if (l.stock < min) min = l.stock;
    }
  }
  return min === Infinity ? null : min;
}

function render() {
  const el = document.getElementById('urgency');
  if (!el) return;

  if (!URGENCY.show) { el.style.display = 'none'; return; }

  const min = lowestStockInCart();
  // Hide unless we have inventory info AND it's below the threshold.
  if (min == null || min >= URGENCY.threshold) {
    el.style.display = 'none';
    el.innerHTML = '';
    return;
  }

  el.style.display = '';
  el.innerHTML = `${SVG}<span>${URGENCY.template.replace('{n}', `<span class="count">${min}</span>`)}</span>`;
}

export function initUrgency() {
  render();
  subscribe(['cart'], render);
}
